export default __webpack_public_path__ + "static/24-0de1294609a96cafef5941b26a265c51.jpg";